import { render, staticRenderFns } from "./GroupCollapse.vue?vue&type=template&id=365c82ad"
import script from "./GroupCollapse.vue?vue&type=script&lang=js"
export * from "./GroupCollapse.vue?vue&type=script&lang=js"
import style0 from "./GroupCollapse.vue?vue&type=style&index=0&id=365c82ad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports